import React, { useState } from "react";
import { Avatar } from "@mui/material";
import ModalSkeleton from "./ModalSkeleton";
import IMG from "../assets/images/Companies_bg.png";
import "../assets/styles/appliedCraftmanModal.css";
import { apiHeader, imageUrl, pdfUrl, URL } from "../Config/apiUrl";
import { useHistory } from "react-router-dom";
import { Col, Row, Form, Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Post } from "../Axios/AxiosFunctions";
import { toast } from "react-toastify";

function AppliedCraftmanModal({
  open,
  setOpen,
  data,
  jobId,
  comment,
  motivationalLetter,
  title,
  companyName,
}) {
  const history = useHistory();
  const [messageText, setMessageText] = useState("");
  const user = useSelector((state) => state.authReducer.user);
  const token = useSelector((state) => state.authReducer.access_token);
  const [isApiCalling, setIsApiCalling] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const leftButtonText = "Visit Profile";
  const rightButtonText = "Send Message";

  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const [showMoreComment, setShowMoreComment] = useState(false);

  const leftButtonCallBack = () => {
    history.push(`/craftman-profile?id=${data._id}`);
  };

  const rightButtonCallBack = async () => {
    if (messageText === "") return;

    // create message
    const newMessage = {
      // _id: 1,
      text: messageText,
      createdAt: new Date(),
      user: {
        _id: user?._id,
        name: user?.companyName,
        avatar: `${imageUrl}${user?.photo}`,
      },
    };

    const params = {
      msg: newMessage,
      msgFrom: user?._id,
      msgTo: data?._id,
      currentUser: user?.UserId?.role,
    };

    // send message
    const url = URL("chat/message/create");
    setIsApiCalling(true);
    const response = await Post(url, params, apiHeader(token));
    setIsApiCalling(false);

    if (response !== undefined) {
      toast.success("Message sent successfully");
      setMessageText("");
    }
  };
  return (
    <ModalSkeleton
      title="Craftman Detail"
      open={open}
      setOpen={setOpen}
      isLoading={isApiCalling}
    >
      <section className="applied-craftsman-modal">
        <div className="profile-img-and-name">
          <Avatar
            align="center"
            src={`${imageUrl}${data?.photo}`}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = IMG;
            }}
            sx={{ width: 120, height: 120 }}
          />
          <h6>{data?.userName}</h6>
        </div>
        <div className="details">
          <ul>
            <li>
              <span>Eductaion:</span>
              {data?.eduction}
            </li>
            <li>
              <span>Experience:</span>
              {data?.experience}
            </li>
            <li>
              <span>Skills:</span>
              {data?.skills?.join(" , ")}
            </li>
            <li>
              <span>Description:</span>
              {!showMoreDescription && data?.description?.length > 100
                ? data?.description.substring(0, 100) + "..."
                : data?.description}
              {data?.description?.length > 100 && (
                <span
                  className="show-more-less"
                  onClick={() => setShowMoreDescription((p) => !p)}
                >
                  {!showMoreDescription ? "Show more" : "Show less"}
                </span>
              )}
            </li>
            {comment !== "" && comment !== null && comment !== undefined && (
              <li>
                <span>Craftman Comments:</span>
                {!showMoreComment && comment?.length > 100
                  ? comment?.substring(0, 100) + "..."
                  : comment}
                {comment?.length > 100 && (
                  <span
                    className="show-more-less"
                    onClick={() => setShowMoreComment((p) => !p)}
                  >
                    {!showMoreComment ? "Show more" : "Show less"}
                  </span>
                )}
              </li>
            )}
            {motivationalLetter !== "" &&
              motivationalLetter !== null &&
              motivationalLetter !== undefined && (
                <li
                  className="c-p"
                  onClick={() =>
                    window.open(`${pdfUrl}${motivationalLetter}`, "_blank")
                  }
                >
                  <span>Motivational Letter:</span>
                  Click to Open
                </li>
              )}
          </ul>
        </div>

        {/* Message */}
        <Row>
          <h5 className="font-26">Send Message</h5>

          <Col md={12} className="mb-3">
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Message here"
              onChange={(e) => setMessageText(e.target.value)}
              name="message"
              value={messageText}
            />
          </Col>
        </Row>
      </section>
      <Modal.Footer>
        <Button
          className="f-14"
          variant="primary"
          onClick={() => {
            // return console.log(jobId, "jsvlwhb;r;bjr;bw")
            history.push({
              pathname: "/Contract",
              state: {
                craftmanId: data?._id,
                jobId: jobId,
                title,
                companyName,
              },
            });
          }}
        >
          Send Contract
        </Button>
        <Button
          variant="secondary"
          style={{ backgroundColor: "#2196f3" }}
          onClick={() => (leftButtonCallBack ? leftButtonCallBack() : null)}
        >
          {leftButtonText || "Close"}
        </Button>
        <Button
          className="f-14"
          style={{ backgroundColor: "#d8289d" }}
          disabled={isApiCalling}
          variant="primary"
          onClick={() => (rightButtonCallBack ? rightButtonCallBack() : null)}
        >
          {isApiCalling ? "Please Wait" : rightButtonText}
        </Button>
      </Modal.Footer>
    </ModalSkeleton>
  );
}

export default AppliedCraftmanModal;
